import Icon from '../../components/Icon'

Icon.register({
  'brands/figma': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M14 95.8c0-52.9 42.9-95.8 95.8-95.8h164.4c52.9 0 95.8 42.9 95.8 95.8 0 33.5-17.2 63-43.2 80.1 26 17.1 43.2 46.6 43.2 80.1 0 52.9-42.9 95.8-95.8 95.8h-2.1c-24.8 0-47.4-9.4-64.4-24.9v88.3c0 53.6-44 96.8-97.4 96.8-52.8 0-96.3-42.8-96.3-95.8 0-33.5 17.2-63 43.2-80.1-26-17.1-43.2-46.6-43.2-80.1 0-33.5 17.2-63 43.2-80.1-26-17.1-43.2-46.6-43.2-80.1zM176.3 191.6h-66.5c-35.6 0-64.4 28.8-64.4 64.4 0 35.4 28.6 64.2 64 64.4 0.1 0 0.3 0 0.4 0h66.5v-128.8zM207.7 256c0 35.6 28.8 64.4 64.4 64.4h2.1c35.6 0 64.4-28.8 64.4-64.4s-28.8-64.4-64.4-64.4h-2.1c-35.6 0-64.4 28.8-64.4 64.4zM109.8 351.8c-0.1 0-0.3 0-0.4 0-35.4 0.2-64 29-64 64.4 0 35.4 29.2 64.4 64.9 64.4 36.3 0 66-29.4 66-65.5v-63.4h-66.5zM109.8 31.4c-35.6 0-64.4 28.8-64.4 64.4 0 35.6 28.8 64.4 64.4 64.4h66.5v-128.8h-66.5zM207.7 160.2h66.5c35.6 0 64.4-28.8 64.4-64.4 0-35.6-28.8-64.4-64.4-64.4h-66.5v128.8z'
      }
    ]
  }
})
